const { instance } = require('./url')

async function getJobCosts(from, to, jobName, customerName, groupBy) {
    return await instance.get('/jobcost', {
        params: {
            from,
            to,
            job_name: jobName || undefined,
            customer_name: customerName || undefined,
            group_by: groupBy || undefined,
        },
    })
}

export { getJobCosts }
